import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === "dark" ? "gray.900" : "gray.50",
        color: props.colorMode === "dark" ? "whiteAlpha.900" : "gray.800",
      },
    }),
  },
  // Color-mode-aware tokens. Use these instead of hardcoded "#fff" so surfaces
  // adapt automatically in dark mode.
  semanticTokens: {
    colors: {
      cardBg: { default: "white", _dark: "gray.800" },
      pageBg: { default: "gray.50", _dark: "gray.900" },
      inputBg: { default: "white", _dark: "gray.700" },
    },
  },
  colors: {
    brand: {
      50: "#fff5e6",
      100: "#ffe0b2",
      200: "#ffcc80",
      300: "#ffb74d",
      400: "#ffa726",
      500: "#ff9800",
      600: "#fb8c00",
      700: "#f57c00",
      800: "#ef6c00",
      900: "#e65100",
    },
  },
});

export default theme;
